React = require 'react'
t = require('views/internal/recup-with-helpers')('header_appcues_menu')
MemberState = require 'view-models/member-state'

module.exports = class extends React.Component
  displayName: 'HeaderAppcuesPopOver'

  constructor: (props) ->
    super
    @state =
      notifyOptOut: MemberState.getAppcuesOptOut()

  onChange: (e) =>
    @setState({ notifyOptOut: !e.target.checked })
    MemberState.setAppcuesOptOut(!e.target.checked)

  render: t.renderable ->
    { appcuesItem: { id, title, img, links, bodyHtml } } = @props

    checked = !@state.notifyOptOut
    onChange = @onChange.bind(@)

    t.div ->
      if img
        t.div '.appcues-tip-image', ->
          t.img '.appcues-tip-image-img', { src: img }
      t.h2 ->
        t.text title
      t.div '.appcues-tip-body', ->
        t.raw bodyHtml
      if links && links.length > 0
        t.ul ->
          links.forEach ({ linkText, linkUrl }) ->
            t.li ->
              t.a { href: linkUrl, target: '_blank' }, ->
                t.span ->
                  t.text linkText
      t.hr()
      t.form ->
        t.div '.check-div.u-clearfix', { style: marginTop: '10px' }, ->
          t.input { type: 'checkbox', id: 'idAppcuesOptOut', name: 'optout', checked, onChange }
          t.label { htmlFor: 'idAppcuesOptOut' }, ->
            t.format 'keep-showing-tips'



// WEBPACK FOOTER //
// ./app/scripts/views/header/header-appcues-popover-component.coffee